<div class="modal-header customBlueHeader">
  <p class="modal-title">Re-Assign Doctor</p>
  <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button> -->
  <button type="button" class="close" aria-label="Close" (click)="modelClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body customModalBody">
  <form [formGroup]="reAssignForm" (ngSubmit)="submitReassignEconsultData(reAssignForm)">
    <div>

      <div class="form-group">
        <label>Doctor Name</label>
        <select class="form-control col-form-label-sm" formControlName="getDoctor">
                <option disabled value="">Select Doctor</option>
                <option *ngFor="let doctor of doctorList.consultation_doctors" [ngValue]="doctor">
                  {{doctor.name}}</option>
        </select>
      </div>

      <!--<div class="form-group">
        <label>Scheduled Date & Time</label>
        <div class="input-group">
          <input class="form-control" (dateSelect)="getSlotData()" [minDate]="minDate" placeholder="yyyy-mm-dd"
            formControlName="selectedDate" name="dp" ngbDatepicker #fD="ngbDatepicker" required>
          <div class="input-group-append">
            <button class="btn btn-outline-secondary calendar" (click)="fD.toggle()" type="button"><i
                class="fa fa-calendar" aria-hidden="true"></i></button>
          </div>
        </div>
        <div>
          <div><label>Select Slot</label></div>
          <select id="timeDropDown" [(ngModel)]="slotTimingInfo" formControlName="slotTime"
            class="form-control col-form-label-sm">
            <option selected>--Select--</option>
            <option [ngValue]="slotRes" *ngFor="let slotRes of slotResponse">
              <!--{{slotRes.from_time}} - {{slotRes.to_time}}-->
              <!--{{slotRes.f_time}}-->
            <!--</option>
          </select>
        </div>
      </div>-->
      <!--<div class="form-group">
        <label>Reason</label>
        <textarea class="form-control col-form-label-sm" formControlName="reason"></textarea>
      </div>-->

    </div>
    <div class="modal-footer customModalFooter bdr-none">
      <button type="submit" class="btn green_btn">Re Assign</button>
    </div>
  </form>


</div>